// 임시 복사, 원본은 @digntec/icons (dign-platform-kit/packages/icons/platform-modules.json, v1.0.0)
// GitHub Packages 토큰(.npmrc) 설정 후 `npm i @digntec/icons` 로 바꾸고 이 파일은 지운다.
// 규칙: 색은 모듈 대표(그룹) 아이콘·라벨에만. 하위 기능 아이콘은 회색. 상태는 STATUS 3색.
export const MODULES = {
  core: { ko: '공통', color: '#475569' },
  sales: { ko: '영업·견적', color: '#028090' },
  project: { ko: '프로젝트·시공', color: '#EA580C' },
  finance: { ko: '재무·정산', color: '#16A34A' },
  service: { ko: '서비스 데스크', color: '#2563EB' },
  asset: { ko: '자산·위치', color: '#7C3AED' },
  device: { ko: '디바이스·운영', color: '#DB2777' },
  knowledge: { ko: '지식·AI', color: '#CA8A04' },
};

export const STATUS = { ok: '#16A34A', warn: '#CA8A04', critical: '#DC2626' };

// 하위 기능 아이콘 색 (회색)
export const SUB_ICON = '#6B7280';

export const moduleColor = (key) => MODULES[key]?.color || SUB_ICON;

/** MUI Chip 등에 쓰는 상태 스타일 — 연한 배경 + 진한 글자 */
export const statusSx = (level) => {
  const c = STATUS[level] || SUB_ICON;
  return { color: c, bgcolor: `${c}14`, border: `1px solid ${c}55`, fontWeight: 600 };
};
